// variant-selector.js - Enhanced version
class VariantImageSelector {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
    this.debugInfo();
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('.variant-selector__image-btn')) {
        this.handleVariantClick(e.target.closest('.variant-selector__image-btn'));
      }
    });
  }

  handleVariantClick(button) {
    const productId = button.dataset.productId;
    const imageSrc = button.dataset.imageSrc;
    const imageAlt = button.dataset.imageAlt;

    // Update active state
    this.updateActiveState(button, productId);

    // Update main image
    this.updateMainImage(productId, imageSrc, imageAlt);
  }

  updateActiveState(activeButton, productId) {
    // Remove active class from all buttons for this product
    const allButtons = document.querySelectorAll(`.variant-selector__image-btn[data-product-id="${productId}"]`);
    allButtons.forEach(btn => btn.classList.remove('active'));
    
    // Add active class to clicked button
    activeButton.classList.add('active');
  }

  updateMainImage(productId, imageSrc, imageAlt) {
    const productCard = document.querySelector(`.product-card[data-product-id="${productId}"]`);
    if (!productCard) return;

    // Try different image selectors
    const imageSelectors = [
      'img[data-main-image]',
      '.card-gallery img',
      'slideshow-slide[active] img',
      'slideshow-slide img',
      '.product-card__media img'
    ];

    let mainImage = null;
    for (const selector of imageSelectors) {
      mainImage = productCard.querySelector(selector);
      if (mainImage) break;
    }

    if (mainImage) {
      // Smooth transition
      mainImage.style.transition = 'opacity 0.3s ease';
      mainImage.style.opacity = '0.6';

      const newImage = new Image();
      newImage.src = imageSrc;
      newImage.alt = imageAlt;

      newImage.onload = () => {
        mainImage.src = imageSrc;
        mainImage.alt = imageAlt;
        mainImage.style.opacity = '1';
        
        // Also update slideshow if exists
        this.updateSlideshow(productCard, imageSrc, imageAlt);
      };

      newImage.onerror = () => {
        mainImage.style.opacity = '1';
        console.warn('Variant image failed to load:', imageSrc);
      };
    }
  }

  updateSlideshow(productCard, imageSrc, imageAlt) {
    const slideshow = productCard.querySelector('slideshow-component');
    if (!slideshow) return;

    const activeSlide = slideshow.querySelector('slideshow-slide[active]');
    if (activeSlide) {
      const slideImage = activeSlide.querySelector('img');
      if (slideImage) {
        slideImage.src = imageSrc;
        slideImage.alt = imageAlt;
      }
    }
  }

  debugInfo() {
    // Log debug info to console
    const productCards = document.querySelectorAll('.product-card');
    console.log('Variant Selector Debug:');
    productCards.forEach(card => {
      const productId = card.dataset.productId;
      const variantCount = card.dataset.variantMediaCount;
      console.log(`Product ${productId}: ${variantCount} variant media`);
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new VariantImageSelector());
} else {
  new VariantImageSelector();
}